import { HeadlessProvider } from '@exodus/headless-react';
import { Provider } from 'react-redux';

import adapters from '@/background/adapters/adapters';
import exodus from '@/ui/exodus';
import { store } from '@/ui/flux';
import selectors from '@/ui/flux/selectors';
import { ConfigProvider } from './config.js';

function AppContext({ children }) {
  return (
    <Provider store={store}>
      <HeadlessProvider
        exodus={exodus}
        selectors={selectors}
        adapters={adapters}
      >
        <ConfigProvider>{children}</ConfigProvider>
      </HeadlessProvider>
    </Provider>
  );
}

export default AppContext;
